import { render, staticRenderFns } from "./NotificationsWebhook.vue?vue&type=template&id=57f9790e&"
import script from "./NotificationsWebhook.vue?vue&type=script&lang=js&"
export * from "./NotificationsWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports